module.exports = __webpack_public_path__ + "static/img/back1.e53569a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page3/back1.png
// module id = 4LY7
// module chunks = 0